import React from 'react';
import { useIntl } from 'react-intl';
import { RouteComponentProps, withRouter } from 'react-router';

import { Button } from '@xsolla/ui-core';
import { useModal } from '@xsolla/ui-modal';

import { RouteParams } from '../../../routes/types';
import { ColumnBlock } from '../../../styled';
import { TestWidgetModal } from '../../App/TestWidgetModal';
import { StyledArea, Text, Title } from './style';

const TryLoginComponent = ({ match }: RouteComponentProps) => {
  const intl = useIntl();
  const { projectId } = match.params as RouteParams;

  const [onOpenTestWidgetModal, onCloseTestWidgetModal] = useModal(
    () => <TestWidgetModal projectId={projectId} onClose={onCloseTestWidgetModal} />,
    []
  );

  return (
    <StyledArea>
      <ColumnBlock>
        <Title>{intl.formatMessage({ id: 'try-login.checklist.title' })}</Title>
        <Text>{intl.formatMessage({ id: 'try-login.checklist.text' })}</Text>
        <div>
          <Button size="sm" onClick={onOpenTestWidgetModal}>
            {intl.formatMessage({ id: 'try-login.checklist.button' })}
          </Button>
        </div>
      </ColumnBlock>
    </StyledArea>
  );
};

export default withRouter(TryLoginComponent);
